import { create } from 'zustand'

/**
 * DNA Integrity Store
 * Holds ConfigurationError state when API returns 503 (DNA not configured).
 * Transforms technical backend errors into helpful frontend guidance.
 */
export const useDNAIntegrityStore = create((set) => ({
  /** Last ConfigurationError from API (503) - { detail, incomplete_sections } */
  configurationError: null,

  /** Set when API returns ConfigurationError - no generic toast, show banner instead */
  setConfigurationError: (payload) =>
    set({
      configurationError: payload
        ? {
            detail: payload.detail || 'Vul eerst je Bedrijfs-DNA in via Setup of Instellingen.',
            incomplete_sections: payload.incomplete_sections || ['financials'],
          }
        : null,
    }),

  /** Clear when user navigates to DNA setup or completes configuration */
  clearConfigurationError: () => set({ configurationError: null }),

  /** DNA Victory: set when user saves DNA successfully - hides banner immediately */
  dnaJustSaved: false,
  setDnaJustSaved: (value) => set({ dnaJustSaved: value }),
}))
